@let header = globalDataService.config().header;
<div
  class="page-content"
  [class.page-content--admin-mode]="adminMode"
  [class.is-scrolling]="isScrolling"
  [class.has-topper]="header.data.headerTopper.display"
>
  <app-header
    [styles]="header.data.styles"
    [logoDisplay]="header.data.logo.display"
    [logoSrc]="header.data.logo.src_data"
    [logoRedirect]="header.data.logo.redirect"
    [topperDisplay]="header.data.headerTopper.display"
    [topperPhone]="header.data.headerTopper.phone"
    [menuItems]="header.data.menu ?? defaultHeaderMenuItems"
  ></app-header>
  <section class="container">
    <div class="maintenance">
      <mat-icon class="material-symbols-outlined">warning</mat-icon>
      <h1 class="maintenance__title h5">Update in Progress</h1>
      <p class="maintenance__text body2">
        This site is undergoing scheduled maintenance.<br /><br />
        We'll be back shortly.</p>
    </div>
  </section>
  @let footer = globalDataService.config().footer;
  <app-footer
    [config]="footer"
  />
</div>
